export function updateMediaQueryState() {
  if (!this.data) {
    this.data = {}
  }
  const { timeout } = this.data
  const el = this
  const floatingPanelState = el.state.parent
  // float panel state is wiped out => float panel is not open => no need to update state
  if (Object.keys(floatingPanelState).length === 0) {
    return
  }

  if (timeout) clearTimeout(timeout)
  this.data.timeout = setTimeout(async () => {
    const { value } = floatingPanelState
    // check if input is valid
    const nodeValue = el.node.value
    // only number -> add px at the end
    if (!isNaN(nodeValue)) {
      el.node.value = `${nodeValue}px`
    }
    if (!validateCssUnitValue(el.node.value)) {
      console.warn('Invalid CSS unit value')
      el.node.value = el.state.value
      return
    }
    el.state.quietUpdate({ value: el.node.value })
    let newFloatingPanelValue
    if (!value) {
      // add: float panel state value is null
      newFloatingPanelValue = `(${el.state.key}: ${el.node.value})`
    } else {
      // update: find the update position to replace the state
      const values = value.split(', ')
      const { position } = el.state
      values[position] = `(${el.state.key}: ${el.node.value})`
      newFloatingPanelValue = values.join(', ')
    }
    floatingPanelState.quietUpdate({ value: newFloatingPanelValue })
    if (timeout) clearTimeout(timeout)
  }, 1 * 1000)
}

function validateCssUnitValue(value) {
  const CssUnitTypes = [
    'em',
    'ex',
    'ch',
    'rem',
    'vw',
    'vh',
    'vmin',
    'vmax',
    '%',
    'cm',
    'mm',
    'in',
    'px',
    'pt',
    'pc'
  ]
  const regexps = CssUnitTypes.map(
    (unit) => new RegExp(`^[0-9]+${unit}$|^[0-9]+\\.[0-9]+${unit}$`, 'i')
  )
  const isValid = regexps.find((regexp) => regexp.test(value)) !== undefined
  return isValid
}
